import { initializeApp, getApps } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const apiKey = import.meta.env.VITE_FIREBASE_WEB_API_KEY ?? "";
const projectID = import.meta.env.VITE_FIREBASE_PROJECT_ID ?? "";
const authDomain = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? (projectID ? `${projectID}.firebaseapp.com` : "");

const app = getApps()[0]
  ?? initializeApp({
    apiKey,
    authDomain,
    projectId: projectID || undefined,
  });

export const firebaseAuth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

googleProvider.setCustomParameters({
  prompt: "select_account",
});
